const API_MINOR_VERSION = 3;
const API_MAJOR_VERSION = "v5";
const API_PROVIDER = "hungryhub";
const API_BASE_URL = "/api";
const SOURCE = "website";
const PROVIDER = "hungryhub";
export {
  API_MINOR_VERSION,
  API_MAJOR_VERSION,
  API_PROVIDER,
  API_BASE_URL,
  SOURCE,
  PROVIDER,
};
